import { PATH } from '@/router/PATH';
import { overviewKey } from '../overview/overviewCard';

const key = (leaf: string): string => overviewKey('balance', leaf);

/** Testid prefix, icon, copy keys and drill target for one tile. */
export type StatTileMeta = {
    id: string;
    icon: string;
    labelKey: string;
    /**
     * Where the chevron goes, or `null` for a tile that only reports.
     *
     * The mock drills into the A/B detail sections, which do not exist. These
     * point at screens that do — a chevron with nowhere to go is the dead
     * affordance this project keeps removing. Repoint them when the sections
     * land.
     */
    href: string | null;
};

export const BALANCE_TILES = {
    currentAssets: {
        id: 'current-assets',
        icon: 'solar:box-minimalistic-bold-duotone',
        labelKey: key('currentAssets'),
        href: PATH.ACCOUNTING.STATEMENTS.BALANCE_SHEET,
    },
    currentLiabilities: {
        id: 'current-liabilities',
        icon: 'solar:card-bold-duotone',
        labelKey: key('currentLiabilities'),
        href: PATH.ACCOUNTING.STATEMENTS.BALANCE_SHEET,
    },
    workingCapital: {
        id: 'working-capital',
        icon: 'solar:transfer-vertical-bold-duotone',
        labelKey: key('workingCapital'),
        // The answer, not a place. It is the subtraction of the two tiles
        // beside it, both of which drill.
        href: null,
    },
    cashCycle: {
        id: 'cash-cycle',
        icon: 'solar:clock-circle-bold-duotone',
        labelKey: key('cashCycle'),
        href: null,
    },
    gmroi: {
        id: 'gmroi',
        icon: 'solar:graph-up-bold-duotone',
        labelKey: key('gmroi'),
        href: PATH.PRODUCTS.ROOT,
    },
} satisfies Record<string, StatTileMeta>;

export const BALANCE_KEYS = {
    title: key('title'),
    subtitle: key('subtitle'),
    windowAria: key('windowAria'),
    days: key('days'),
    times: key('times'),
    verdict: {
        STRAINED: key('verdict.strained'),
        STABLE: key('verdict.stable'),
        STRONG: key('verdict.strong'),
    },
    gmroiVerdict: {
        STRAINED: key('gmroiVerdict.strained'),
        STABLE: key('gmroiVerdict.stable'),
        STRONG: key('gmroiVerdict.strong'),
    },
};
